<div class="occ-public-page">
  <div class="container py-5" style="max-width: 760px;">
    <div class="text-center mb-4">
      <span class="brand-badge">🛡️</span>
      <h1 class="h2 mt-3 mb-1">Canal de denúncias</h1>
      <p class="text-muted mb-0">Escolha o que pretende fazer.</p>
    </div>

    <div class="row g-3">
      <div class="col-12 col-md-6">
        <a class="occ-reason w-100 text-start" [routerLink]="['/', tenant, 'participar']"
           [queryParams]="{ motivo: 'denuncia', origem: 'canal' }">
          <span class="occ-reason-icon occ-reason-icon--sensitive"><i class="fe fe-shield"></i></span>
          <span class="occ-reason-body">
            <span class="occ-reason-label">Apresentar uma denúncia</span>
            <span class="occ-reason-desc">Comunicar uma suspeita de irregularidade, infração ou conduta imprópria.</span>
          </span>
        </a>
      </div>
      <div class="col-12 col-md-6">
        <a class="occ-reason w-100 text-start" [routerLink]="['/', tenant, 'acompanhar']"
           [queryParams]="{ origem: 'canal' }">
          <span class="occ-reason-icon"><i class="fe fe-search"></i></span>
          <span class="occ-reason-body">
            <span class="occ-reason-label">Acompanhar uma denúncia</span>
            <span class="occ-reason-desc">Consultar o estado de uma denúncia já apresentada com o código de acompanhamento.</span>
          </span>
        </a>
      </div>
    </div>
  </div>
</div>
